export default __webpack_public_path__ + "static/media/CW__3035.2f978d8d.jpg";